import React from 'react';

const Star: React.FC<React.PropsWithChildren> = () => (
  <path d="M8.00003 11.3334L4.08137 13.7267L5.1467 9.26008L1.66003 6.27341L6.2367 5.90675L8.00003 1.66675L9.76337 5.90675L14.3407 6.27341L10.8534 9.26008L11.9187 13.7267L8.00003 11.3334ZM8.00003 9.77075L9.87803 10.9174L9.36737 8.77742L11.0387 7.34608L8.84537 7.17008L8.00003 5.13875L7.1547 7.17008L4.96137 7.34608L6.6327 8.77742L6.12203 10.9174L8.00003 9.77141V9.77075Z" />
);

export default Star;
